import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	closeButton: {
		id: 'workflow-view-diagram-modal.close-button',
		defaultMessage: 'Close',
		description: 'Label for the button to close the workflow view diagram modal',
	},
	anyStatusTransitionLabel: {
		id: 'workflow-view-diagram-modal.any-status-transition-label',
		defaultMessage: 'ANY STATUS',
		description:
			'Message that indicates this transition can be used from "any status" in the workflow.',
	},
	startNodeLabel: {
		id: 'workflow-view-diagram-modal.start-node-label',
		defaultMessage: 'START',
		description: 'Label for the start node in the workflow.',
	},
	errorMessage: {
		defaultMessage: 'We couldn’t load the workflow.',
		id: 'workflow-view-diagram-modal.error-message',
		description: 'Error message for when the modal fails to load its content',
	},
});
